<template>
  <div>
    <b-row class="mt-4">
      <b-col lg="12">
        <h4>IBS</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="2">
        <InputMoney label="Diferimento UF" disabled :precision="2" :value="vDifUF" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Dev. Tributos UF" disabled :precision="2" :value="vDevTribUF" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="IBS UF" disabled :precision="2" :value="vIBSUF" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Diferimento Mun" disabled :precision="2" :value="vDifMun" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Dev. Tributos Mun" disabled :precision="2" :value="vDevTribMun" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="IBS Mun" disabled :precision="2" :value="vIBSMun" />
      </b-col>
    </b-row>
    <b-row class="mt-lg-2">
      <b-col lg="2">
        <InputMoney label="Créd. Pres." disabled :precision="2" :value="vCredPres" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Créd. Pres. Sus" disabled :precision="2" :value="vCredPresCondSus" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="IBS Mono." disabled :precision="2" :value="vIBSMono" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="IBS Mono. Ret." disabled :precision="2" :value="vIBSMonoRet" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="IBS Mono. Reten" disabled :precision="2" :value="vIBSMonoReten" />
      </b-col>
      <b-col lg="2">
        <InputMoney label="Total IBS" disabled :precision="2" :value="vIBSTot" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { InputMoney } from '@/components/Form';

export default {
  name: 'IBSTaxes',
  components: {
    InputMoney,
  },
  props: {
    IbsTaxRegimeTotals: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vDifUF() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSUF?.vDif || 0;
    },
    vDevTribUF() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSUF?.vDevTrib || 0;
    },
    vIBSUF() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSUF?.vIBSUF || 0;
    },
    vDifMun() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSMun?.vDif || 0;
    },
    vDevTribMun() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSMun?.vDevTrib || 0;
    },
    vIBSMun() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.gIBSMun?.vIBSMun || 0;
    },
    vCredPres() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.vCredPres || 0;
    },
    vCredPresCondSus() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.vCredPresCondSus || 0;
    },
    vIBSMono() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vIBSMono || 0;
    },
    vIBSMonoRet() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vIBSMonoRet || 0;
    },
    vIBSMonoReten() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gMono?.vIBSMonoReten || 0;
    },
    vIBSTot() {
      return this.IbsTaxRegimeTotals?.IBSCBSTot?.gIBS?.vIBS || 0;
    },
  },
};
</script>
